import React, { memo } from 'react';
import CountUp from 'react-countup';
import styles from './progressBar.module.scss';

export default memo(function ProgressBar(props) {
    return (
        <div className={styles.container}>
            <div className={styles.barContainer}>
                <div style={{ flex: props.percentage / 100 }}>
                    <div className={styles.foreground} />
                </div>
            </div>
            <span>
                <CountUp duration={2} end={props.percentage} redraw />%
            </span>

        </div>
    );
}, (prevProps, nextProps) => prevProps.percentage === nextProps.percentage);
